export const innitialthemeSettingsJson: any =
{
    "#204ecf": {
        "layoutType": "vertical",
        "leftSidebarType": "light",
        "layoutModeType": "light",
        "layoutWidthType": "lg",
        "layoutPositionType": "fixed",
        "topbarThemeType": "dark",
        "leftsidbarSizeType": "lg",
        "leftSidebarViewType": "default",
        "leftSidebarImageType": "img-1",
        "preloader": "disable",
        "sidebarVisibilitytype": "show",
        "themePrimary": "",
        "themeSecondary": "",
        "dark_logo": "logo_ac9a0885-bd57-4b40-a4a7-284866051cfe_zoomabroad_logo.png", //<==-- prod logo and qa logo=>"logo_34ba422b-9c74-449e-8af3-23c7c6c80b3e_zoomabroad_logo.png",
        "light_logo":  "logo_7be1a6ac-f0d8-4d02-99e5-c97474e53677_zoomabroad_logo_white.png", ////<==-- prod logo and qa logo=> "logo_4d54382f-0997-427f-8945-49670542c93a_zoomabroad_logo_white.png",
        "dark_logo_sm": "logo_38b3c1da-a38e-4529-8d64-29da32ff6dfb_zoomabroad_logo-sm.png", ////<==-- prod logo and qa logo=> "logo_4336938c-18fd-4c19-851d-e6396219ae6d_zoomabroad_logo-sm.png"
        "light_logo_sm": "logo_af519873-c227-4525-bdb5-e3294f2175ef_zoomabroad_logo_white-sm.png" ////<==-- prod logo and qa logo=> "logo_b3a3bd45-6fdb-41c8-8488-5760624ec036_zoomabroad_logo_white-sm.png"
    },
    "#a735b3": {
        "layoutType": "horizontal",
        "layoutModeType": "light",
        "leftSidebarType": "light",
        "layoutWidthType": "lg",
        "layoutPositionType": "fixed",
        "topbarThemeType": "dark",
        "leftsidbarSizeType": "default",
        "leftSidebarViewType": "default",
        "leftSidebarImageType": "none",
        "preloader": "disable",
        "sidebarVisibilitytype": "show",
        "themePrimary": "",
        "themeSecondary": '',
        "light_logo": '',
        "dark_logo": '',
        "light_logo_sm": '',
        "dark_logo_sm": ''
    }
}